var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SmallSectionTitle"},[(_vm.sectionNumber)?_c('div',{staticClass:"section-number h-5-bold text-center"},[_vm._v(" "+_vm._s(_vm.sectionNumber)+" ")]):_vm._e(),_c('div',{staticClass:"h-2-bold h-5-bold",class:{
      'app-color-2': _vm.color === 'blue',
      'app-color-black': _vm.color === 'black',
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }